import React from "react";
import { filter } from "lodash";
import styled, { css } from "styled-components";

import { Chart, Stats } from "@components/moleculs";
import { device } from "@scss/constants/mediaQuery";

import type { FC } from "react";
import type { DateRange, Filters, Statistic } from "@interfaces/stats";

type StatisticsProps = {
  filters: Partial<Filters>;
  statistic: Statistic[];
  dateRange: DateRange;
};

const Statistics: FC<StatisticsProps> = ({ filters, statistic, dateRange }) => {
  const onTimeCount = filter(statistic, (item) => item.onTime).length;
  const onTimePercent = ((onTimeCount / statistic.length) * 100).toFixed(2);

  return (
    <Wrapper>
      <Stats
        filters={filters}
        dateRange={dateRange}
        onTimePercent={onTimePercent}
      />
      <Chart statistic={statistic} />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
  max-width: 1680px;
  height: 600px;
  min-height: 270px;

  margin: 0 auto;

  display: flex;
  align-items: center;
  flex-direction: column-reverse;

  ${device.laptopS(css`
    flex-direction: row;
    justify-content: center;
    height: 80%;
  `)}
`;

export default Statistics;
